<template>  
  <global-mission ref="map" :uiid="uiid" >
    <slot></slot>
  </global-mission>
</template>
<script>
  import { mapGetters } from 'vuex'    
  import GlobalMission from '@/views/pilot/GlobalMission'    
  import {buildMissionUIStateId} from '@/models/ui/MissionUiState'
  export default {
    name: 'MissionDetailMap',   
    components:{GlobalMission},
    props:{
      uiid:{
          type: String,
          required: true
      }
    },          
    created() {             
      this.$store.myActions.UI_ENSURE_MAP_STATE(this.uiid)
    },
    watch : {
      uiid(newValue) {
        this.$store.myActions.UI_ENSURE_MAP_STATE(newValue)
      },
      leftPanelWidth(newSize) {
        if(this.$refs.map) this.$refs.map.resizeMap()
      },
      componentRefresh(){    
        if(this.$refs.map) this.$refs.map.resizeMap()            
      },
      infosPanelVisible(){
        if(this.$refs.map) this.$refs.map.resizeMap()
      }
    },             
    computed: {
      ...mapGetters([            
        'currentDetailMission',
        'uistatebyuiid'
      ]),     
      leftPanelWidth(){
        return this.currentDetailMission.leftPanelWidth
      },
      mission_uiid() {
        return buildMissionUIStateId(this.currentDetailMission.mission.misId,"detail")
      },
      //recupere le state de travail
      infosPanelVisible() { 
        //retourne un MapUiState        
        return this.uistatebyuiid(this.mission_uiid) && this.uistatebyuiid(this.mission_uiid).infosPanelVisible       
      },
      mapState() {                  
        return this.uistatebyuiid(this.uiid)
      },
      componentRefresh() {
        return this.mapState && this.mapState.refresh
      }
    },
    methods: {
    }
  }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  
</style>
